import React from "react";
import SigninForm from "../UI/components/auth/SigninForm";

const SigninPage = () => {
    return <SigninForm />;
};

export default SigninPage;